import * as React from 'react';
import moment from 'moment';
import cn from 'classnames';
import { DateTimePicker } from '../../DateTimePicker';

import styles from '../MultiSelectSearch.module.scss';

const DatePeriodSearch: React.FC<IProps> = props => (
  <div className={styles.fields} key="period">
      <div className={styles.field_title}>ПЕРИОД</div>
      <DateTimePicker
        from={props.from}
        to={props.to}
        fetch={props.onChange}
        setFrom={props.setFrom}
        setTo={props.setTo}
        firstDateProps={{ placeholder: 'Дата начала' }}
        secondDateProps={{ placeholder: 'Окончание' }}
        containerClassName={cn(styles.field_value, styles.date_container)}
        groupClassName={styles.date_group}
        withoutLabels
      />
  </div>
);

interface IProps {
    from?: moment.Moment;
    to?: moment.Moment;
    onChange: (date: { to?: moment.Moment; from?: moment.Moment }) => void;
    setFrom: (date?: moment.Moment) => void;
    setTo: (date?: moment.Moment) => void;
}

export default DatePeriodSearch;
